package org.example.zone360.pages.coachDetails.sessionAllDetails.sentimentsBox

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetSessionsData
import org.example.zone360.models.Sentimentprob
import org.example.zone360.models.SessionDataDetailsResponse
import org.example.zone360.pages.dashboard.SectionTitle
import org.example.zone360.theme.Palette
import org.example.zone360.theme.SitePalette
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun SentimentBox(
    sessionData: GetSessionsData,
    sitePalette: SitePalette
) {
    val sentiments = sessionData.sementics.sentiments
    val totalUsed = sentiments.sumOf { it.percentage }
    val remainder = (100 - totalUsed).coerceAtLeast(0)

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .margin(top = 15.px)
            .borderRadius(12.px)
            .border(1.px, style = LineStyle.Solid, color = sitePalette.coachDetailsBoxBorder.rgb)
            .padding(16.px)
            .boxShadow(
                offsetY = 1.px,
                blurRadius = 3.px,
                color = sitePalette.textFieldTextColor.rgb.copyf(alpha = 0.1f)
            )
    ) {
        Column(modifier = Modifier.fillMaxWidth()) {
            SectionTitle("Sentiment")

            // Sentiment bar
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .borderRadius(8.px)
                    .height(8.px)
            ) {
                sentiments.forEachIndexed { index, item ->
                    val bgColor = when (item.label.lowercase()) {
                        "positive" -> Palette.PositiveColor.rgbLight
                        "corrective" -> Palette.NegativeColor.rgbLight
                        "informational" -> Palette.NeutralColor.rgbLight
                        else -> Palette.LightGrey.rgbLight
                    }

                    val isLast = index == sentiments.lastIndex && remainder == 0

                    Box(
                        modifier = Modifier
                            .fillMaxHeight()
                            .width(item.percentage.percent)
                            .backgroundColor(bgColor)
                            .borderRadius(
                                topLeft = if (index == 0) 8.px else 0.px,
                                bottomLeft = if (index == 0) 8.px else 0.px,
                                topRight = if (isLast) 8.px else 0.px,
                                bottomRight = if (isLast) 8.px else 0.px
                            )
                    )
                }

                if (remainder > 0) {
                    Box(
                        modifier = Modifier
                            .fillMaxHeight()
                            .width(remainder.percent)
                            .backgroundColor(Palette.LightGrey.rgbLight)
                            .borderRadius(topRight = 8.px, bottomRight = 8.px)
                    )
                }
            }
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .margin(topBottom = 10.px)
                    .gap(8.px)
                    .flexWrap(FlexWrap.Wrap),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                sentiments.forEach { sentiment ->
                    val dotColor = when (sentiment.label.lowercase()) {
                        "positive" -> Palette.PositiveColor.rgbLight
                        "corrective" -> Palette.NegativeColor.rgbLight
                        "informational" -> Palette.NeutralColor.rgbLight
                        else -> Palette.LightGrey.rgbLight
                    }

                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Box(
                            modifier = Modifier
                                .size(10.px)
                                .borderRadius(1.67.px)
                                .backgroundColor(dotColor)
                        )
                        FieldTitleTextNormalSimple(
                            text = "${sentiment.label}: ${sentiment.percentage}%",
                            marginLeft = 10.px,
                            fontSize = 12.px
                        )
                    }
                }
            }
        }
    }
}

